module.exports = __webpack_public_path__ + "static/media/017-C.P.R. Tavern.f5c141ee.jpg";